import { Link } from 'react-router-dom';
import Routes from '../configuration/routes/RouteList';

const Landing = () => {
  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'oklch(0.13 0.008 260)',
        color: 'oklch(0.97 0.004 260)',
        fontFamily: 'system-ui, -apple-system, sans-serif',
        overflowX: 'hidden',
      }}
    >
      <title>NiuMedia — Your Personal Media Intelligence</title>

      <style>{`
        @keyframes gradientShift {
          0%   { transform: translateX(-50%) rotate(0deg) scale(1); }
          50%  { transform: translateX(-50%) rotate(180deg) scale(1.15); }
          100% { transform: translateX(-50%) rotate(360deg) scale(1); }
        }
        @keyframes orb1 {
          0%, 100% { transform: translate(0, 0); }
          33%       { transform: translate(60px, -40px); }
          66%       { transform: translate(-40px, 30px); }
        }
        @keyframes orb2 {
          0%, 100% { transform: translate(0, 0); }
          33%       { transform: translate(-50px, 50px); }
          66%       { transform: translate(40px, -30px); }
        }
        @keyframes orb3 {
          0%, 100% { transform: translate(0, 0); }
          50%       { transform: translate(30px, 40px); }
        }
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(24px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes shimmer {
          0%   { background-position: -200% center; }
          100% { background-position: 200% center; }
        }
        @keyframes pulse {
          0%, 100% { opacity: 0.6; transform: scale(1); }
          50%       { opacity: 1;   transform: scale(1.05); }
        }
        @keyframes borderGlow {
          0%, 100% { border-color: oklch(1 0 0 / 0.08); }
          50%       { border-color: oklch(0.52 0.22 265 / 0.35); }
        }
        .nm-nav-link:hover { color: oklch(0.9 0.01 260) !important; border-color: oklch(1 0 0 / 0.2) !important; }
        .nm-btn-primary:hover { opacity: 0.88; transform: translateY(-1px); }
        .nm-btn-secondary:hover { background: oklch(1 0 0 / 0.07) !important; }
        .nm-feature-card:hover {
          border-color: oklch(0.52 0.22 265 / 0.3) !important;
          transform: translateY(-3px);
          box-shadow: 0 12px 40px oklch(0.52 0.22 265 / 0.12);
        }
        .nm-feature-card { transition: border-color 200ms, transform 200ms, box-shadow 200ms; }
        .nm-stat-value {
          background: linear-gradient(135deg, oklch(0.9 0.02 260), oklch(0.72 0.18 265));
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        .nm-hero-badge {
          animation: fadeUp 0.6s ease both;
        }
        .nm-hero-h1 {
          animation: fadeUp 0.6s 0.1s ease both;
        }
        .nm-hero-p {
          animation: fadeUp 0.6s 0.2s ease both;
        }
        .nm-hero-cta {
          animation: fadeUp 0.6s 0.3s ease both;
        }
        .nm-hero-card {
          animation: fadeUp 0.8s 0.4s ease both;
        }
        .nm-shimmer-text {
          background: linear-gradient(
            90deg,
            oklch(0.72 0.18 265) 0%,
            oklch(0.9 0.05 265) 40%,
            oklch(0.65 0.22 300) 60%,
            oklch(0.72 0.18 265) 100%
          );
          background-size: 200% auto;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          animation: shimmer 4s linear infinite;
        }
        .nm-scroll-hint {
          animation: pulse 2.5s ease infinite;
        }
        .nm-btn-primary, .nm-btn-secondary { transition: opacity 150ms, transform 150ms, background 150ms; }
      `}</style>

      {/* ── Ambient orbs ── */}
      <div style={{ position: 'fixed', inset: 0, pointerEvents: 'none', zIndex: 0, overflow: 'hidden' }}>
        <div style={{
          position: 'absolute', top: '8%', left: '15%', width: '500px', height: '500px',
          borderRadius: '50%',
          background: 'radial-gradient(circle, oklch(0.52 0.22 265 / 0.09) 0%, transparent 70%)',
          animation: 'orb1 18s ease-in-out infinite',
        }} />
        <div style={{
          position: 'absolute', top: '40%', right: '10%', width: '420px', height: '420px',
          borderRadius: '50%',
          background: 'radial-gradient(circle, oklch(0.55 0.2 300 / 0.07) 0%, transparent 70%)',
          animation: 'orb2 22s ease-in-out infinite',
        }} />
        <div style={{
          position: 'absolute', bottom: '10%', left: '30%', width: '360px', height: '360px',
          borderRadius: '50%',
          background: 'radial-gradient(circle, oklch(0.5 0.22 240 / 0.07) 0%, transparent 70%)',
          animation: 'orb3 15s ease-in-out infinite',
        }} />
      </div>

      {/* ── Nav ── */}
      <nav style={{
        position: 'sticky', top: 0, zIndex: 50,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '0 max(24px, calc(50% - 580px))',
        height: '56px',
        borderBottom: '1px solid oklch(1 0 0 / 0.06)',
        background: 'oklch(0.13 0.008 260 / 0.82)',
        backdropFilter: 'blur(16px)',
        WebkitBackdropFilter: 'blur(16px)',
      }}>
        <Link to={Routes.Landing} style={{ display: 'flex', alignItems: 'center', gap: '8px', textDecoration: 'none' }}>
          <span style={{
            fontWeight: 800, fontSize: '15px', letterSpacing: '-0.04em',
            background: 'linear-gradient(135deg, oklch(0.78 0.18 260), oklch(0.65 0.22 300))',
            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
          }}>NM</span>
          <span style={{ fontSize: '14px', fontWeight: 600, letterSpacing: '-0.02em', color: 'oklch(0.9 0.004 260)' }}>
            <strong>Niu</strong><em style={{ fontStyle: 'normal', opacity: 0.55 }}>Media</em>
          </span>
        </Link>

        <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
          {[
            { label: 'Features', href: '#features' },
            { label: 'How it works', href: '#how' },
          ].map(({ label, href }) => (
            <a
              key={label}
              href={href}
              className="nm-nav-link"
              style={{
                fontSize: '13px', fontWeight: 500,
                color: 'oklch(0.6 0.01 260)',
                textDecoration: 'none',
                transition: 'color 150ms',
              }}
            >
              {label}
            </a>
          ))}
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Link
            to={Routes.Login}
            className="nm-nav-link"
            style={{
              fontSize: '13px', fontWeight: 500,
              padding: '6px 14px', borderRadius: '7px',
              color: 'oklch(0.7 0.01 260)',
              textDecoration: 'none',
              border: '1px solid oklch(1 0 0 / 0.1)',
              background: 'transparent',
              transition: 'border-color 150ms, color 150ms',
            }}
          >
            Sign in
          </Link>
          <Link
            to={Routes.Register}
            className="nm-btn-primary"
            style={{
              fontSize: '13px', fontWeight: 600,
              padding: '6px 16px', borderRadius: '7px',
              color: '#fff', textDecoration: 'none',
              background: 'oklch(0.52 0.22 265)',
              boxShadow: '0 0 0 1px oklch(0.52 0.22 265), 0 2px 12px oklch(0.52 0.22 265 / 0.3)',
            }}
          >
            Get started
          </Link>
        </div>
      </nav>

      {/* ── Hero ── */}
      <section style={{
        padding: '110px max(24px, calc(50% - 580px)) 90px',
        textAlign: 'center',
        position: 'relative',
        zIndex: 1,
      }}>
        {/* Rotating gradient disc */}
        <div style={{
          position: 'absolute', top: '-120px', left: '50%',
          width: '900px', height: '700px',
          background: 'conic-gradient(from 0deg, oklch(0.52 0.22 265 / 0.12), oklch(0.55 0.2 300 / 0.08), transparent, oklch(0.5 0.22 240 / 0.1), oklch(0.52 0.22 265 / 0.12))',
          borderRadius: '50%',
          animation: 'gradientShift 20s linear infinite',
          pointerEvents: 'none',
          filter: 'blur(40px)',
        }} />

        {/* Badge */}
        <div className="nm-hero-badge" style={{
          display: 'inline-flex', alignItems: 'center', gap: '6px',
          fontSize: '11px', fontWeight: 600, letterSpacing: '0.06em',
          textTransform: 'uppercase', padding: '4px 12px', borderRadius: '20px',
          background: 'oklch(0.52 0.22 265 / 0.1)',
          border: '1px solid oklch(0.52 0.22 265 / 0.25)',
          color: 'oklch(0.72 0.18 265)', marginBottom: '28px',
        }}>
          <span style={{
            width: '5px', height: '5px', borderRadius: '50%',
            background: 'oklch(0.72 0.18 265)',
            display: 'inline-block', animation: 'pulse 2s ease infinite',
          }} />
          Now with local AI transcription
        </div>

        <h1 className="nm-hero-h1" style={{
          fontSize: 'clamp(38px, 7vw, 76px)',
          fontWeight: 800, letterSpacing: '-0.045em',
          lineHeight: 1.02, margin: '0 auto 24px', maxWidth: '820px',
        }}>
          Your media,{' '}
          <span className="nm-shimmer-text">intelligently organized</span>
        </h1>

        <p className="nm-hero-p" style={{
          fontSize: 'clamp(15px, 2vw, 18px)',
          color: 'oklch(0.62 0.01 260)', lineHeight: 1.75,
          maxWidth: '540px', margin: '0 auto 44px', fontWeight: 400,
        }}>
          Archive YouTube channels, transcribe audio with Whisper, and search your entire media library — all in one self-hosted platform.
        </p>

        <div className="nm-hero-cta" style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link
            to={Routes.Register}
            className="nm-btn-primary"
            style={{
              display: 'inline-flex', alignItems: 'center', gap: '6px',
              fontSize: '15px', fontWeight: 700, padding: '13px 28px',
              borderRadius: '10px', color: '#fff', textDecoration: 'none',
              background: 'oklch(0.52 0.22 265)',
              boxShadow: '0 0 0 1px oklch(0.52 0.22 265), 0 6px 32px oklch(0.52 0.22 265 / 0.4)',
            }}
          >
            Create free account →
          </Link>
          <Link
            to={Routes.Login}
            className="nm-btn-secondary"
            style={{
              display: 'inline-flex', alignItems: 'center',
              fontSize: '14px', fontWeight: 500, padding: '13px 24px',
              borderRadius: '10px', color: 'oklch(0.75 0.01 260)',
              textDecoration: 'none',
              border: '1px solid oklch(1 0 0 / 0.1)',
              background: 'oklch(1 0 0 / 0.04)',
            }}
          >
            Sign in instead
          </Link>
        </div>

        {/* App preview card */}
        <div className="nm-hero-card" style={{
          marginTop: '72px',
          maxWidth: '880px', marginLeft: 'auto', marginRight: 'auto',
          borderRadius: '18px',
          border: '1px solid oklch(1 0 0 / 0.1)',
          background: 'oklch(0.16 0.008 260)',
          boxShadow: '0 48px 100px oklch(0 0 0 / 0.55), 0 0 0 1px oklch(0.52 0.22 265 / 0.08)',
          overflow: 'hidden',
          position: 'relative',
        }}>
          {/* Top shimmer line */}
          <div style={{
            position: 'absolute', top: 0, left: 0, right: 0, height: '1px',
            background: 'linear-gradient(90deg, transparent 0%, oklch(0.72 0.18 265 / 0.6) 40%, oklch(0.65 0.22 300 / 0.5) 60%, transparent 100%)',
          }} />

          {/* Window chrome */}
          <div style={{ padding: '14px 18px', borderBottom: '1px solid oklch(1 0 0 / 0.06)', display: 'flex', alignItems: 'center', gap: '8px' }}>
            {['oklch(0.55 0.18 30)', 'oklch(0.7 0.18 90)', 'oklch(0.55 0.18 140)'].map((c, i) => (
              <div key={i} style={{ width: '10px', height: '10px', borderRadius: '50%', background: c, opacity: 0.75 }} />
            ))}
            <div style={{
              flex: 1, height: '22px', borderRadius: '6px',
              background: 'oklch(0.22 0.008 260)',
              border: '1px solid oklch(1 0 0 / 0.07)',
              display: 'flex', alignItems: 'center', paddingLeft: '10px',
              fontSize: '10px', color: 'oklch(0.4 0.01 260)', fontFamily: 'monospace',
            }}>
              niumedia.local / downloads
            </div>
          </div>

          {/* Mock content */}
          <div style={{ padding: '20px', display: 'grid', gridTemplateColumns: '200px 1fr', gap: '16px' }}>
            {/* Sidebar */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              {[
                { label: 'Home', icon: '🏠', active: false },
                { label: 'Downloads', icon: '⬇', active: true },
                { label: 'Channels', icon: '📺', active: false },
                { label: 'Upload', icon: '🎙', active: false },
                { label: 'Search', icon: '🔍', active: false },
              ].map(item => (
                <div
                  key={item.label}
                  style={{
                    display: 'flex', alignItems: 'center', gap: '8px',
                    padding: '7px 10px', borderRadius: '7px', fontSize: '12px',
                    background: item.active ? 'oklch(0.52 0.22 265 / 0.15)' : 'transparent',
                    color: item.active ? 'oklch(0.82 0.15 265)' : 'oklch(0.5 0.01 260)',
                    fontWeight: item.active ? 600 : 400,
                  }}
                >
                  <span style={{ fontSize: '13px' }}>{item.icon}</span>
                  {item.label}
                </div>
              ))}
            </div>

            {/* Main area */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {[
                { title: 'Building AI Applications in 2025', channel: 'ML Papers Explained', progress: 72, status: 'done' },
                { title: 'The Future of Self-Hosting', channel: 'TechCraft', progress: 100, status: 'done' },
                { title: 'Docker Deep Dive — Complete Course', channel: 'DevOps Journey', progress: 38, status: 'downloading' },
                { title: 'Elasticsearch for Developers', channel: 'Search Mastery', progress: 0, status: 'queued' },
              ].map((item, i) => (
                <div
                  key={i}
                  style={{
                    padding: '10px 12px', borderRadius: '9px',
                    background: 'oklch(0.2 0.008 260)',
                    border: `1px solid ${item.status === 'downloading' ? 'oklch(0.52 0.22 265 / 0.25)' : 'oklch(1 0 0 / 0.06)'}`,
                    display: 'flex', flexDirection: 'column', gap: '6px',
                  }}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div>
                      <div style={{ fontSize: '11px', fontWeight: 600, color: 'oklch(0.88 0.004 260)', letterSpacing: '-0.01em' }}>
                        {item.title}
                      </div>
                      <div style={{ fontSize: '10px', color: 'oklch(0.48 0.01 260)', marginTop: '2px' }}>
                        {item.channel}
                      </div>
                    </div>
                    <span style={{
                      fontSize: '9px', fontWeight: 700, padding: '2px 7px', borderRadius: '4px',
                      letterSpacing: '0.06em', textTransform: 'uppercase',
                      background: item.status === 'done' ? 'oklch(0.55 0.18 140 / 0.15)'
                        : item.status === 'downloading' ? 'oklch(0.52 0.22 265 / 0.15)'
                        : 'oklch(1 0 0 / 0.06)',
                      color: item.status === 'done' ? 'oklch(0.72 0.18 140)'
                        : item.status === 'downloading' ? 'oklch(0.72 0.18 265)'
                        : 'oklch(0.45 0.01 260)',
                    }}>
                      {item.status}
                    </span>
                  </div>
                  {item.status !== 'queued' && (
                    <div style={{ height: '3px', borderRadius: '2px', background: 'oklch(1 0 0 / 0.08)', overflow: 'hidden' }}>
                      <div style={{
                        height: '100%', borderRadius: '2px', width: `${item.progress}%`,
                        background: item.status === 'done'
                          ? 'linear-gradient(90deg, oklch(0.55 0.18 140), oklch(0.65 0.2 160))'
                          : 'linear-gradient(90deg, oklch(0.52 0.22 265), oklch(0.65 0.22 300))',
                        transition: 'width 1s ease',
                      }} />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Scroll hint */}
        <div className="nm-scroll-hint" style={{ marginTop: '40px', fontSize: '11px', color: 'oklch(0.38 0.01 260)', letterSpacing: '0.06em', textTransform: 'uppercase' }}>
          ↓ scroll to explore
        </div>
      </section>

      {/* ── Stats ── */}
      <section style={{
        padding: '0 max(24px, calc(50% - 580px))',
        borderTop: '1px solid oklch(1 0 0 / 0.06)',
        borderBottom: '1px solid oklch(1 0 0 / 0.06)',
        display: 'flex', justifyContent: 'center',
        position: 'relative', zIndex: 1,
      }}>
        {[
          { value: '100%', label: 'Self-hosted' },
          { value: '0', label: 'Data leaves your server' },
          { value: '6+', label: 'Transcription providers' },
          { value: '∞', label: 'Archive capacity' },
        ].map((stat, i) => (
          <div
            key={i}
            style={{
              flex: '1 1 0', textAlign: 'center',
              padding: '28px 16px',
              borderRight: i < 3 ? '1px solid oklch(1 0 0 / 0.06)' : 'none',
            }}
          >
            <div className="nm-stat-value" style={{ fontSize: '32px', fontWeight: 800, letterSpacing: '-0.04em' }}>
              {stat.value}
            </div>
            <div style={{ fontSize: '12px', color: 'oklch(0.5 0.01 260)', marginTop: '4px', fontWeight: 400 }}>
              {stat.label}
            </div>
          </div>
        ))}
      </section>

      {/* ── Features ── */}
      <section id="features" style={{ padding: '100px max(24px, calc(50% - 580px))', position: 'relative', zIndex: 1 }}>
        <div style={{ textAlign: 'center', marginBottom: '64px' }}>
          <p style={{ fontSize: '11px', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'oklch(0.65 0.18 265)', marginBottom: '12px' }}>
            Everything you need
          </p>
          <h2 style={{ fontSize: 'clamp(26px, 4vw, 44px)', fontWeight: 800, letterSpacing: '-0.03em', margin: '0 auto 16px', maxWidth: '520px' }}>
            Built for media power users
          </h2>
          <p style={{ fontSize: '15px', color: 'oklch(0.58 0.01 260)', maxWidth: '440px', margin: '0 auto', lineHeight: 1.7 }}>
            Archive, transcribe, and search your entire media collection with no monthly subscriptions.
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '16px' }}>
          {[
            { icon: '📺', title: 'YouTube Archiver', desc: 'Download entire channels, playlists, or individual videos. Monitor for new uploads automatically with scheduled tasks.' },
            { icon: '🎙', title: 'AI Transcription', desc: 'Convert any audio or video to searchable text. Supports local Whisper or cloud providers like OpenAI and Groq.' },
            { icon: '🔍', title: 'Full-text Search', desc: 'Search across transcripts, titles, and descriptions. Find any specific moment across thousands of hours of content.' },
            { icon: '👥', title: 'Multi-user Spaces', desc: 'Each user has their own isolated library. Invite your team or family — everyone keeps their own archive.' },
            { icon: '🔒', title: 'Fully Private', desc: 'Your data never leaves your server. Run everything locally with complete control over your content.' },
            { icon: '⚡', title: 'Multi-provider', desc: 'Choose between local Whisper, cloud APIs, or bring your own endpoint. Switch providers any time without losing data.' },
          ].map((feature, i) => (
            <div
              key={i}
              className="nm-feature-card"
              style={{
                padding: '26px',
                borderRadius: '14px',
                border: '1px solid oklch(1 0 0 / 0.08)',
                background: 'oklch(0.16 0.008 260)',
                position: 'relative', overflow: 'hidden',
              }}
            >
              <div style={{
                position: 'absolute', top: 0, left: 0, right: 0, height: '1px',
                background: 'linear-gradient(90deg, transparent, oklch(0.52 0.22 265 / 0.25), transparent)',
              }} />
              <div style={{
                width: '44px', height: '44px', borderRadius: '11px',
                background: 'oklch(0.21 0.01 265)',
                border: '1px solid oklch(0.52 0.22 265 / 0.2)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: '22px', marginBottom: '16px',
              }}>
                {feature.icon}
              </div>
              <h3 style={{ fontSize: '14px', fontWeight: 700, letterSpacing: '-0.02em', margin: '0 0 8px', color: 'oklch(0.92 0.004 260)' }}>
                {feature.title}
              </h3>
              <p style={{ fontSize: '13px', color: 'oklch(0.56 0.01 260)', lineHeight: 1.7, margin: 0 }}>
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* ── How it works ── */}
      <section id="how" style={{
        padding: '80px max(24px, calc(50% - 580px))',
        borderTop: '1px solid oklch(1 0 0 / 0.06)',
        position: 'relative', zIndex: 1,
      }}>
        <div style={{ textAlign: 'center', marginBottom: '60px' }}>
          <p style={{ fontSize: '11px', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'oklch(0.65 0.18 265)', marginBottom: '12px' }}>
            Simple workflow
          </p>
          <h2 style={{ fontSize: 'clamp(24px, 4vw, 40px)', fontWeight: 800, letterSpacing: '-0.03em', margin: 0 }}>
            Up and running in minutes
          </h2>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '0', position: 'relative' }}>
          {[
            { step: '01', title: 'Deploy', desc: 'Self-host with Docker Compose. Your data stays on your machine, always.' },
            { step: '02', title: 'Create account', desc: 'Sign up and invite others. Each user gets their own private space.' },
            { step: '03', title: 'Archive', desc: 'Add YouTube channels or upload any audio file to your library.' },
            { step: '04', title: 'Search', desc: 'Find any moment across your entire media library instantly.' },
          ].map((item, i) => (
            <div
              key={i}
              style={{
                padding: '36px 28px',
                borderLeft: i > 0 ? '1px solid oklch(1 0 0 / 0.06)' : 'none',
                position: 'relative',
              }}
            >
              <div style={{
                display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                width: '32px', height: '32px', borderRadius: '8px',
                background: 'oklch(0.52 0.22 265 / 0.12)',
                border: '1px solid oklch(0.52 0.22 265 / 0.25)',
                fontSize: '11px', fontWeight: 800, color: 'oklch(0.72 0.18 265)',
                fontFamily: 'monospace', marginBottom: '14px',
              }}>
                {item.step}
              </div>
              <h3 style={{ fontSize: '16px', fontWeight: 700, letterSpacing: '-0.02em', margin: '0 0 8px', color: 'oklch(0.92 0.004 260)' }}>
                {item.title}
              </h3>
              <p style={{ fontSize: '13px', color: 'oklch(0.55 0.01 260)', lineHeight: 1.7, margin: 0 }}>
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* ── CTA ── */}
      <section style={{
        padding: '100px max(24px, calc(50% - 580px))',
        textAlign: 'center',
        position: 'relative', zIndex: 1,
      }}>
        <div style={{
          maxWidth: '580px', margin: '0 auto',
          padding: '60px 48px', borderRadius: '24px',
          border: '1px solid oklch(1 0 0 / 0.1)',
          background: 'oklch(0.16 0.008 260)',
          position: 'relative', overflow: 'hidden',
          boxShadow: '0 0 80px oklch(0.52 0.22 265 / 0.08)',
          animation: 'borderGlow 4s ease infinite',
        }}>
          {/* Top shimmer */}
          <div style={{
            position: 'absolute', top: 0, left: 0, right: 0, height: '1px',
            background: 'linear-gradient(90deg, transparent 0%, oklch(0.72 0.18 265 / 0.7) 40%, oklch(0.65 0.22 300 / 0.6) 60%, transparent 100%)',
          }} />
          <div style={{
            position: 'absolute', bottom: '-80px', left: '50%',
            transform: 'translateX(-50%)',
            width: '400px', height: '250px',
            background: 'radial-gradient(ellipse, oklch(0.52 0.22 265 / 0.1) 0%, transparent 70%)',
            pointerEvents: 'none',
          }} />

          <div style={{
            display: 'inline-flex', alignItems: 'center', gap: '6px',
            fontSize: '11px', fontWeight: 600, letterSpacing: '0.06em',
            textTransform: 'uppercase', padding: '4px 12px', borderRadius: '20px',
            background: 'oklch(0.52 0.22 265 / 0.1)',
            border: '1px solid oklch(0.52 0.22 265 / 0.25)',
            color: 'oklch(0.72 0.18 265)', marginBottom: '24px',
          }}>
            Free · Self-hosted · Private
          </div>

          <h2 style={{ fontSize: 'clamp(24px, 4vw, 36px)', fontWeight: 800, letterSpacing: '-0.035em', margin: '0 0 14px', color: 'oklch(0.97 0.004 260)' }}>
            Take control of your media
          </h2>
          <p style={{ fontSize: '15px', color: 'oklch(0.58 0.01 260)', lineHeight: 1.7, margin: '0 0 36px' }}>
            No subscriptions. No cloud lock-in. Your content, your rules.
          </p>

          <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link
              to={Routes.Register}
              className="nm-btn-primary"
              style={{
                display: 'inline-flex', alignItems: 'center', gap: '6px',
                fontSize: '15px', fontWeight: 700, padding: '13px 32px',
                borderRadius: '10px', color: '#fff', textDecoration: 'none',
                background: 'oklch(0.52 0.22 265)',
                boxShadow: '0 0 0 1px oklch(0.52 0.22 265), 0 8px 36px oklch(0.52 0.22 265 / 0.45)',
              }}
            >
              Create account →
            </Link>
            <Link
              to={Routes.Login}
              className="nm-btn-secondary"
              style={{
                display: 'inline-flex', alignItems: 'center',
                fontSize: '14px', fontWeight: 500, padding: '13px 24px',
                borderRadius: '10px', color: 'oklch(0.7 0.01 260)',
                textDecoration: 'none',
                border: '1px solid oklch(1 0 0 / 0.1)',
                background: 'oklch(1 0 0 / 0.04)',
              }}
            >
              Sign in
            </Link>
          </div>
        </div>
      </section>

      {/* ── Footer ── */}
      <footer style={{
        padding: '24px max(24px, calc(50% - 580px))',
        borderTop: '1px solid oklch(1 0 0 / 0.06)',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        flexWrap: 'wrap', gap: '12px', position: 'relative', zIndex: 1,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{
            fontWeight: 800, fontSize: '13px', letterSpacing: '-0.04em',
            background: 'linear-gradient(135deg, oklch(0.78 0.18 260), oklch(0.65 0.22 300))',
            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
          }}>NM</span>
          <span style={{ fontSize: '12px', color: 'oklch(0.38 0.01 260)' }}>NiuMedia · Self-hosted media server</span>
        </div>
        <div style={{ display: 'flex', gap: '20px' }}>
          {[
            { label: 'Sign in', to: Routes.Login },
            { label: 'Register', to: Routes.Register },
            { label: 'Privacy', to: Routes.Privacy },
            { label: 'Terms', to: Routes.Terms },
          ].map(({ label, to }) => (
            <Link
              key={label}
              to={to}
              style={{ fontSize: '12px', color: 'oklch(0.4 0.01 260)', textDecoration: 'none' }}
            >
              {label}
            </Link>
          ))}
        </div>
      </footer>
    </div>
  );
};

export default Landing;
